import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { IntegrationsListQuery, IntegrationsListQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(IntegrationsListQuery)
@Wrapper(IntegrationsListQueryHandlerBase)
export class IntegrationsListQueryHandler {
    public constructor(
        http: Http
    ) { }
}
